import { createDialog } from '@patsnap/tahiti-core';

export function createRequestGlossary() {
    return createDialog(() => import('@/presentation/pages/translation/components/TranslationGlossaryDialog.vue'));
}
